import { useMediaQuery } from '@/hooks/useMediaQuery'

/** Matches Tailwind's `max-sm:` variant, so markup and behaviour switch together. */
export const PHONE_QUERY = '(max-width: 639px)'

/**
 * True while the viewport is phone-width. Used by the floating surfaces that dock to
 * the bottom edge there instead of anchoring to their trigger.
 */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_QUERY)
}
